export { Pizza as default } from './Pizza';
